module.exports = __webpack_public_path__ + "static/media/thumbnail.a33351db.jpg";